import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import EducacaoService from '../../../../../../services/contasEducacao-auth';
import { Link, useParams, Navigate } from 'react-router-dom';
import Moment from 'moment';


const DespesaEduc = () => {
    let { id } = useParams()

    const [fonte, setFonte] = useState("");
    const [credor, setCredor] = useState("");
    const [objeto, setObjeto] = useState("");
    const [data, setData] = useState("");
    const [valor, setValor] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    async function fetchDespesa(id) {
        const response = await EducacaoService.despesaEdit(id);
        setFonte(response.data["fonte"]);
        setObjeto(response.data["objeto"]);
        setCredor(response.data["credor"]);
        setValor(response.data["valor"]);
        setData(Moment(response.data["data"]).utc(false).format("yyyy-MM-DD"));
    }

    useEffect(() => {
        fetchDespesa(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const despesa = await EducacaoService.editarDespesa(id, {
                fonte: fonte,
                objeto: objeto,
                data: data,
                credor: credor,
                valor: valor
            })
            if (despesa.data["_id"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }

    const ponto = (campo) => {
        return campo.replace(/,/g, ".");
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="fonte">
                                <FloatingLabel
                                    label="fonte"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="fonte"
                                        value={fonte}
                                        onChange={e => setFonte(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Valor Captado">
                                <FloatingLabel
                                    label="Valor"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="valor"
                                        value={valor}
                                        onChange={e => setValor(ponto(e.target.value))} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Data">
                                <FloatingLabel
                                    label="Data"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="data"
                                        value={data}
                                        onChange={e => setData(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="credor">
                                <FloatingLabel
                                    label="Credor"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="credor"
                                        value={credor}
                                        onChange={e => setCredor(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="objeto">
                                <FloatingLabel
                                    label="Objeto"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="objeto"
                                        value={objeto}
                                        onChange={e => setObjeto(e.target.value)}
                                        as="textarea"
                                        rows={3}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/educacao/despesas/listar'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Despesa editada com sucesso!</Alert>
                <Navigate to={'/restrito/educacao/despesas/listar'} />
            </Fragment>
        )
    }
}

export default DespesaEduc;